import React, {useState} from 'react';
import classnames from 'classnames';
import dayjs from "dayjs";
import FilterInput from "../../../../../../common/components/FilterInput";
import FilterSelect from "../../../../../../common/components/FilterSelect";
import FilterDate from "../../../../../../common/components/FiltersDateFromTo/FilterDate";
import FieldCheckbox from "../../../../../../common/components/FieldCheckbox";
import ButtonExportToExcel from "../../../../../../modules/Inspection/components/ButtonExportToExcel";
import ButtonDropdownCommon from "../../../../../../common/components/ButtonDropdownCommon";
import {excelFileNames as N} from "../../../../constants/excelFileNames";
import {taxAuthorityColumns} from "../../../../../../common/constants/gridColumns";
import {convertBinaryToString} from "../../../../../../common/utils/form/convertBinaryToString";
import {generateExcelFile} from "../../../../utils/exportToExcel";
import {getSalePricePart} from "../../../../../../common/utils/form/getSalePricePart";
import styles from './styles.module.scss';
import ButtonCommon from "../../../../../../common/components/ButtonCommon";
import deleteIcon from "../../../../../../common/assets/delete-24px.svg";

const TableFilters = ({
                        search: {
                          city,
                          street,
                          houseNumber,
                          fromGush,
                          toGush,
                          fromHelka,
                          toHelka,
                          propertyType,
                          fromSalePrice,
                          toSalePrice,
                          fromSaleDate,
                          toSaleDate,
                          fromRegisteredArea,
                          toRegisteredArea,
                          fromRoomsCount,
                          toRoomsCount,
                          fromEstimatePrice,
                          toEstimatePrice,
                          sellType,
                          floor,
                          floorsCount,
                          fromBuildYear,
                          toBuildYear,
                          buildingAge,
                          buildingUnitFunction,
                          fromMunicipalArea,
                          toMunicipalArea,
                          soldShare,
                          parking,
                          elevator,
                          gallery,
                          yard,
                          storage,
                          roof,
                          lot,
                          removeDuplicates,
                        },
                        options,
                        resetAllFilters,
                        getListForExcel
                      }) => {
  const [lastYear, setLastYear] = useState(false);
  const [last2Years, setLast2Years] = useState(false);
  const [last3Years, setLast3Years] = useState(false);

  const headersForExcel = taxAuthorityColumns.map(item => item.Header);
  const preparedDataForExcel = async (dataForExcel) => {

    return Array.isArray(dataForExcel) && dataForExcel.map((item, index) => {
      return {
        [headersForExcel[0]]: index + 1,
        [headersForExcel[1]]: item?.gushHelkaTtHelka ?? '',
        [headersForExcel[2]]: item?.saleDate ? dayjs(item.saleDate).format('DD-MM-YYYY') : '',
        [headersForExcel[3]]: item?.city ?? '',
        [headersForExcel[4]]: item?.street ?? '',
        [headersForExcel[5]]: item?.houseNumber ?? '',
        [headersForExcel[6]]: item?.entranceNumber ?? '',
        [headersForExcel[7]]: item?.apartmentNumber ?? '',
        [headersForExcel[8]]: item?.salePrice ?? '',
        [headersForExcel[9]]: item?.estimatePrice ?? '',
        [headersForExcel[10]]: item?.brutoAreaType ?? '',
        [headersForExcel[11]]: item?.brutoAreaInSquareMeters ?? '',
        [headersForExcel[12]]: item?.netAreaType ?? '',
        [headersForExcel[13]]: item?.netAreaInSquareMeters ?? '',
        [headersForExcel[14]]: item?.buildYear ?? '',
        [headersForExcel[15]]: item?.pricePerRoom ?? '',
        [headersForExcel[16]]: item?.pricePerSquareMeter ?? '',
        [headersForExcel[17]]: item?.roomCount ?? '',
        [headersForExcel[18]]: item?.floor ?? '',
        [headersForExcel[19]]: item?.floorsCount ?? '',
        [headersForExcel[20]]: item?.roomsCount ?? '',
        [headersForExcel[21]]: item?.parking ?? '',
        [headersForExcel[22]]: convertBinaryToString(item?.elevator),
        [headersForExcel[23]]: item?.roof ?? '',
        [headersForExcel[24]]: convertBinaryToString(item?.storage),
        [headersForExcel[25]]: item?.yard ?? '',
        [headersForExcel[26]]: convertBinaryToString(item?.lot),
        [headersForExcel[27]]: convertBinaryToString(item?.gallery),
        [headersForExcel[28]]: item?.sellType ?? '',
        [headersForExcel[29]]: item?.propertyType ?? '',
        [headersForExcel[30]]: item?.soldShare ?? '',
        [headersForExcel[31]]: item?.essenseOfRight ?? '',
        [headersForExcel[32]]: item?.netAreaInSquareMeters && item?.roomCount
          ? (item?.netAreaInSquareMeters / item?.roomCount).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
          : '',
        [headersForExcel[33]]: item?.salePrice && item?.soldShare
          ? (Number(item?.salePrice.replace(/,/g, "")) * getSalePricePart(item?.soldShare)).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          })
          : ''
      };
    });
  };
  const handleExportToExcel = async () => {
    const dataForExcel = await getListForExcel();
    const data = await preparedDataForExcel(dataForExcel);
    generateExcelFile([{data, title: headersForExcel}], N.TAB_TAX_AUTHORITY)
  };

  return (
    <div className={styles.filtersContainer}>
      <div className={styles.threeInRow}>
        <FilterSelect
          placeholder="עיר"
          filter={city}
          options={options.cities}
        />
        <FilterSelect
          placeholder="רחוב"
          filter={street}
          options={options.streets}
          disabled={!city?.value || city?.value === -1}
        />
        <FilterInput
          placeholder="בית"
          value={houseNumber.value}
          onChange={event => houseNumber.onChange(event.target.value)}
        />
      </div>
      <div className={styles.threeInRow}>
        <div className={styles.filtersInColumn}>
          <FilterInput
            placeholder="מגוש"
            value={fromGush.value}
            onChange={event => fromGush.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="עד גוש"
            value={toGush.value}
            onChange={event => toGush.onChange(event.target.value)}
          />
        </div>
        <div className={styles.filtersInColumn}>
          <FilterInput
            placeholder="מחלקה"
            value={fromHelka.value}
            onChange={event => fromHelka.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="עד חלקה"
            value={toHelka.value}
            onChange={event => toHelka.onChange(event.target.value)}
          />
        </div>
        <div className={styles.filtersInColumn}>
          <FilterInput
            placeholder="ממחיר המכירה"
            value={fromSalePrice.value}
            onChange={event => fromSalePrice.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="עד מחיר מכירה"
            value={toSalePrice.value}
            onChange={event => toSalePrice.onChange(event.target.value)}
          />
        </div>
      </div>
      <div className={styles.threeInRow}>
        <div className={styles.filtersInColumn}>
          <FilterInput
            placeholder="משטח"
            value={fromRegisteredArea.value}
            onChange={event => fromRegisteredArea.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="עד שטח"
            value={toRegisteredArea.value}
            onChange={event => toRegisteredArea.onChange(event.target.value)}
          />
        </div>
        <div className={styles.filtersInColumn}>
          <FilterInput
            placeholder="ממספר חדרים"
            value={fromRoomsCount.value}
            onChange={event => fromRoomsCount.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="עד מספר חדרים"
            value={toRoomsCount.value}
            onChange={event => toRoomsCount.onChange(event.target.value)}
          />
        </div>
        <div className={styles.filtersInColumn}>
          <FilterDate
            placeholder={'מתאריך העסקה'}
            filter={fromSaleDate}
            maxDate={dayjs(fromSaleDate.value)}
            onChange={(value) => {
              fromSaleDate.onChange(value);
              setLastYear(false);
              setLast2Years(false);
              setLast3Years(false);
            }}
          />
          <FilterDate
            placeholder={'עד תאריך עסקה'}
            filter={toSaleDate}
            minDate={dayjs(toSaleDate.value)}
            onChange={(value) => {
              toSaleDate.onChange(value);
              setLastYear(false);
              setLast2Years(false);
              setLast3Years(false);
            }}
          />
        </div>
      </div>
      <div className={styles.fourInRow}>
        <FilterInput
          placeholder="סוג הנכס"
          value={propertyType.value}
          onChange={event => propertyType.onChange(event.target.value)}
        />
        <FieldCheckbox
          fieldId={'lastYear'}
          variant={'slider'}
          checked={lastYear}
          label={'בשנה האחרונה'}
          onChange={(e) => {
            if (e.target.checked) {
              fromSaleDate.onChange(dayjs().startOf('year'));
              toSaleDate.onChange(dayjs());
              setLast2Years(false);
              setLast3Years(false);
            }
            setLastYear(e.target.checked);
          }}
          containerStyles={styles.sliderMargins}
        />
        <FieldCheckbox
          fieldId={'last2Years'}
          variant={'slider'}
          checked={last2Years}
          label={'שנתיים אחרונות'}
          onChange={(e) => {
            if (e.target.checked) {
              fromSaleDate.onChange(dayjs().subtract(2, 'year'))
              toSaleDate.onChange(dayjs())
              setLastYear(false);
              setLast3Years(false);
            }
            setLast2Years(e.target.checked);
          }}
          containerStyles={styles.sliderMargins}
        />
        <FieldCheckbox
          fieldId={'last3Years'}
          variant={'slider'}
          checked={last3Years}
          label={'שלוש השנים האחרונות'}
          onChange={(e) => {
            if (e.target.checked) {
              fromSaleDate.onChange(dayjs().subtract(3, 'year'));
              toSaleDate.onChange(dayjs());
              setLastYear(false);
              setLast2Years(false);
            }
            setLast3Years(e.target.checked);
          }}
          containerStyles={styles.sliderMargins}
        />
      </div>
      <div className={styles.buttonsContainer}>
        <ButtonDropdownCommon
          triggerComponent={<div className={styles.ddButton}>+</div>}
          customMenuStyles={styles.extraFiltersContainer}
          customMenuFallsStyles={styles.alignToBottom}
          content={[
            <div className={styles.threeInRow}>
              <FilterInput
                placeholder="ממחיר מוצהר"
                value={fromEstimatePrice.value}
                onChange={event => fromEstimatePrice.onChange(event.target.value)}
              />
              <FilterDate
                placeholder={'משנת בניה'}
                filter={fromBuildYear}
                maxDate={dayjs(toBuildYear.value)}
                dateFormat={'YYYY'}
                picker={'year'}
              />
              <FilterInput
                placeholder="משטח ארנונה"
                value={fromMunicipalArea.value}
                onChange={event => fromMunicipalArea.onChange(event.target.value)}
              />
            </div>,
            <div className={styles.threeInRow}>
              <FilterInput
                placeholder="עד מחיר מוצהר"
                value={toEstimatePrice.value}
                onChange={event => toEstimatePrice.onChange(event.target.value)}
              />
              <FilterDate
                placeholder={'עד שנת בניה'}
                filter={toBuildYear}
                dateFormat={'YYYY'}
                picker={'year'}
              />
              <FilterInput
                placeholder="עד שטח ארנונה"
                value={toMunicipalArea.value}
                onChange={event => toMunicipalArea.onChange(event.target.value)}
              />
            </div>,
            <div className={styles.threeInRow}>
              <FilterInput
                placeholder="סוג העסקה"
                value={sellType.value}
                onChange={event => sellType.onChange(event.target.value)}
              />
              <FilterInput
                placeholder="קומה"
                value={floor.value}
                onChange={event => floor.onChange(event.target.value)}
              />
              <FilterInput
                placeholder="מספר קומות"
                value={floorsCount.value}
                onChange={event => floorsCount.onChange(event.target.value)}
              />
            </div>,
            <div className={styles.twoInRow}>
              <FilterInput
                placeholder="גיל בניין"
                value={buildingAge.value}
                onChange={event => buildingAge.onChange(event.target.value)}
              />
              <FilterInput
                placeholder="פונקציית יחידת בניין"
                value={buildingUnitFunction.value}
                onChange={event => buildingUnitFunction.onChange(event.target.value)}
              />
            </div>,
            <div className={classnames(styles.threeInRow, styles.w100)}>
              <FieldCheckbox
                fieldId={'soldShare'}
                variant={'slider'}
                checked={soldShare?.value}
                label={'מניה שנמכרה (מלאה/חלקית)'}
                onChange={(e) => soldShare.onChange(e.target.checked)}
                containerStyles={styles.sliderMargins}
                customLabelStyles={styles.checkboxSmallerFont}
              />
              <FieldCheckbox
                fieldId={'parking'}
                variant={'slider'}
                checked={parking?.value}
                label={'חניה'}
                onChange={(e) => parking.onChange(e.target.checked)}
                containerStyles={styles.sliderMargins}
              />
              <FieldCheckbox
                fieldId={'elevator'}
                variant={'slider'}
                checked={elevator?.value}
                label={'מעלית'}
                onChange={(e) => elevator.onChange(e.target.checked)}
                containerStyles={styles.sliderMargins}
              />
            </div>,
            <div className={classnames(styles.threeInRow, styles.w100)}>
              <FieldCheckbox
                fieldId={'gallery'}
                variant={'slider'}
                checked={gallery?.value}
                label={'גלריה'}
                onChange={(e) => gallery.onChange(e.target.checked)}
                containerStyles={styles.sliderMargins}
              />
              <FieldCheckbox
                fieldId={'yard'}
                variant={'slider'}
                checked={yard?.value}
                label={'חצר'}
                onChange={(e) => yard.onChange(e.target.checked)}
                containerStyles={styles.sliderMargins}
              />
              <FieldCheckbox
                fieldId={'storage'}
                variant={'slider'}
                checked={storage?.value}
                label={'מחסן'}
                onChange={(e) => storage.onChange(e.target.checked)}
                containerStyles={styles.sliderMargins}
              />
            </div>,
            <div className={classnames(styles.threeInRow, styles.w100)}>
              <FieldCheckbox
                fieldId={'roof'}
                variant={'slider'}
                checked={roof?.value}
                label={'גג'}
                onChange={(e) => roof.onChange(e.target.checked)}
                containerStyles={styles.sliderMargins}
              />
              <FieldCheckbox
                fieldId={'lot'}
                variant={'slider'}
                checked={lot?.value}
                label={'מגרש'}
                onChange={(e) => lot.onChange(e.target.checked)}
                containerStyles={styles.sliderMargins}
              />
              <FieldCheckbox
                fieldId={'removeDuplicates'}
                variant={'slider'}
                checked={removeDuplicates?.value}
                label={'הסר כפילויות'}
                onChange={(e) => removeDuplicates.onChange(e.target.checked)}
                containerStyles={styles.sliderMargins}
              />
            </div>,
          ]}
        />
        <ButtonCommon
          label={
            <div className={styles.clearAllLabel}>
              <img src={deleteIcon} alt="i"/>
              <span>נקה הכל</span>
            </div>
          }
          onClick={() => {
            resetAllFilters();
            setLastYear(false);
            setLast2Years(false);
            setLast3Years(false);
          }}
          customContainerStyles={styles.clearAllButton}
        />
        <ButtonExportToExcel onClick={handleExportToExcel}/>
      </div>
    </div>
  );
};

export default TableFilters;